export const LISTING = 'listing'
export const ADD = 'add'
export const BY_ID = 'by_id'